import { default as Thumb } from './FeaturedDeviationThumb';

export default Thumb;
